import { select } from '@ngneat/elf';
import {UIEntitiesRef, selectManyByPredicate, getAllEntitiesApply} from '@ngneat/elf-entities';
import { getAuditsDataSource } from './audits.requests';
import { auditsStore } from './audits.store';

export class AuditsQuery {
  store = auditsStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  filters = this.store.getValue().filters;

  audits$ = getAuditsDataSource.data$();
  auditsMerges$ = this.store.pipe(select((state) => state.auditsMerge));
  selectedAudits$ = this.store.pipe(
    selectManyByPredicate((auditUi) => auditUi.selected, { pluck: 'id', ref: UIEntitiesRef }),
  );


  get totalRows() {
    return this.store.getValue().pagination.total;
  }

  get selectedAudits() {
    return this.store.query(
        getAllEntitiesApply({
          mapEntity: (e) => e.id,
          filterEntity: (e) => e.selected,
          ref: UIEntitiesRef,
        })
    );
  }
}

export const auditsQuery = new AuditsQuery();
